import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './__mocks__';
import { Payment, PaymentChartFilters } from './types/types';

export const paymenByCategoriesApi = createApi({
  reducerPath: 'paymenByCategoriesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/paymen-by-categories`,
  }),
  tagTypes: ['Payments'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getPaymentspaymenByCategories: builder.query<
      Payment[],
      PaymentChartFilters
    >({
      query: params => ({
        url: ``,
        params,
      }),
      providesTags: ['Payments'],
    }),
  }),
});

export const { useGetPaymentspaymenByCategoriesQuery } = paymenByCategoriesApi;
